module.exports = __webpack_public_path__ + "img/cacung.8890c9ad.png";